<template>
  <v-autocomplete
    v-bind="$attrs"
    :value="value"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :loading="loading"
    autocomplete="disabled"
    :return-object="returnObject || returnObjectAndValue"
    :search-input.sync="search"
    v-on="{ ...$listeners, input: onInput }"
  >
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template v-for="(_, name) in $scopedSlots" #[name]="props">
      <slot :name="name" v-bind="props"></slot>
    </template>
  </v-autocomplete>
</template>
<script>
import Vue from "vue";
import { debounce } from "debounce";

export default Vue.extend({
  props: {
    getter: {
      required: true,
      type: Function,
    },
    value: [String, Number, Array, Object],
    searchInput: {
      required: false,
      default: "",
      type: String,
    },
    itemValue: { type: String, default: "uuid" },
    itemText: { type: String, default: "name" },
    returnObjectAndValue: Boolean,
    limit: {
      type: Number,
      default: 10,
    },
    autoSelectFirst: Boolean,
  },
  data() {
    return {
      items: [],
      stopNext: false,
      search: this.searchInput,
      loading: false,
    };
  },
  computed: {
    returnObject() {
      return this.$attrs["return-object"] || this.$attrs["return-object"] === "";
    },
  },
  methods: {
    refresh() {
      this.newItems();
    },
    async newItems() {
      try {
        this.loading = true;
        const response = await this.getter({
          search: this.search,
          limit: this.limit,
        });
        this.items = response.data.results;
        if (this.autoSelectFirst && !!this.items[0]) {
          if (this.$attrs.returnObject || this.returnObjectAndValue) {
            this.onInput(this.items[0]);
          } else {
            this.onInput(this.items[0][this.itemValue]);
          }
        }
      } finally {
        this.loading = false;
      }
    },
    onInput(e) {
      this.stopNext = true;
      if (this.returnObjectAndValue) {
        this.$emit("input", e[this.itemValue]);
        this.$emit("selected-object", e);
      } else {
        this.$emit("input", e);
      }
    },
    filter() {
      if (this.stopNext) {
        this.stopNext = false;
        return;
      }
      if (this.search) {
        this.loading = true;
        const timeout = setTimeout(() => {
          this.loading = false;
        }, 2500);
        this.filterDebounce(this, this.search, timeout);
      }
    },
    stopNextFilter() {
      this.stopNext = true;
    },
    filterDebounce: debounce(async (vm, search, timeout) => {
      const response = await vm.getter({ search: search, limit: vm.limit });
      clearTimeout(timeout);
      vm.loading = false;
      vm.items = response.data.results;
    }, 200),
  },
  watch: {
    search() {
      try {
        this.filter();
      } catch (error) {
        console.log(error);
      }
    },
    searchInput(value) {
      this.search = value;
      this.filter();
    },
  },
  mounted() {
    this.newItems();
  },
});
</script>
